import httpClient from "./httpClient"; // Adjust path if necessary

const TeamMemberService = {
  async findAll(page, pageSize) {
    return await httpClient.get("/member", {
      params: { page, pageSize }
    });
  },

  async findById(id) {
    return await httpClient.get(`/member/${id}`);
  },

  async getByRole(roleId) {
    return await httpClient.get(`/member/get-by-role/${roleId}`);
  },

  async create(entity) {
    return await httpClient.post("/member", entity);
  },

  async update(id, entity) {
    return await httpClient.put(`/member/${id}`, entity);
  },

  async delete(id) {
    return await httpClient.delete(`/member/${id}`);
  }
};

export default TeamMemberService;
